import { createSlice } from "@reduxjs/toolkit";

const initialverficationState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  verificationList: [],
  verificationStatus: null,
  error: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const verificationSlice = createSlice({
  name: "Verifications",
  initialState: initialverficationState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.payload.error?.response?.data.message}`;
      switch (action.payload.callType) {
        case callTypes.list:
          state.listLoading = false;
          break;
        case callTypes.action:
          state.actionsLoading = false;
          break;
        default:
          break;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      switch (action.payload.callType) {
        case callTypes.list:
          state.listLoading = true;
          break;
        case callTypes.action:
          state.actionsLoading = true;
          break;
        default:
          break;
      }
    },
    verificationsFetched: (state, action) => {
      state.verificationList = action.payload.verificationList;
      state.listLoading = false;
      state.error = null;
    },
    verificationSolved: (state, action) => {
      state.verificationList = state.verificationList.filter(
        (elem) => elem.id !== action.payload.verificationStatus.verification.id
      );
      state.verificationStatus = action.payload.verificationStatus.verification;
      state.actionsLoading = false;
      state.error = null;
    },
  },
});
